// Import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// Import icons
import { faUser, faPlus, faSave, faSignInAlt, faSignOutAlt, faTable, faCog, faSpinner } from "@fortawesome/free-solid-svg-icons";

export default {
  init: () => library.add(
    faUser, faPlus, faSave, faSignInAlt, faSignOutAlt, faTable, faCog, faSpinner
  )
}
